import styled from "styled-components";
import StepLabel from "@material-ui/core/StepLabel";
import Step from "@material-ui/core/Step";
import StepConnector from "@material-ui/core/StepConnector";
import Stepper from "@material-ui/core/Stepper";
import TextField from "@material-ui/core/TextField";
import { TYPOGRAPHY, COLORS } from "../../../constants";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActionArea from "@material-ui/core/CardActionArea";
import { Avatar } from "@material-ui/core";

import Autocomplete from "react-google-autocomplete";

export const StyledStepConnector = styled(StepConnector)`
  && {
    &&.MuiStepConnector-vertical {
      padding: 0px;
      height: 0px;
    }

    .MuiStepConnector-line {
      border-color: white;
    }
  }

  &&.MuiStepConnector-active {
    .MuiStepConnector-line {
      border-color: white;
    }
  }

  &&.MuiStepConnector-completed {
    .MuiStepConnector-line {
      border-color: white;
    }
  }
`;


export const SideNavHeading = styled.div`
font-family: SF Pro Text;
font-size: 15px;
font-weight: 500;
line-height: 20px;
letter-spacing: 0px;
text-align: left;
background: #ffffff;
margin-top: 35px;
marging-left: 50px;
padding-left: 20px;
`;


export const ScreenRoot = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.isMobile ? "column" : "row")};
  ${(props) => (props.isMobile ? "position: relative;" : "")}
  width: 100%;
  max-width: 1440px;
  ${(props) => (props.isMobile ? "" : "align-content: center;")}
  ${(props) => (props.isMobile ? "" : "justify-content: center;")}
  ${(props) => (props.isMobile ? "padding: 70px 0 0 0;" : "padding: 60px 0px 0px 0px;")}
  background-color: ${COLORS.backgroundGrey};
`;



export const FormContainer = styled.div`
  width: ${(props) => (props.isMobile ? "85%" : "100%")};
  ${(props) => (props.isMobile ? "align-self: center;" : "")}
  padding-bottom: 20px;
  margin-top: ${(props) => (props.isMobile ? "16px" : "-70px")};
  display: flex;
  flex-direction: column;
  border-left: ${(props) => (props.leftBorder ? "3px solid #EBE9F1" : "none")};
`;

export const StyledStepLabel = styled(StepLabel)`
  && {
    .MuiStepLabel-labelContainer {
      font-family: ${TYPOGRAPHY.primaryFont};
      font-weight: 400;
      color: ${COLORS.lightGrey2};
    }

    .MuiStepLabel-iconContainer {
      padding: 0;
    }

    .MuiStepLabel-label.MuiStepLabel-active {
      color: ${COLORS.textGrey};
      font-weight: 600;
    }

    .MuiStepLabel-label.MuiStepLabel-completed {
      color: ${COLORS.lightGrey2};
      font-weight: 400;
    }

    .MuiStepLabel-label {
      font-size: 13px;
      color: ${COLORS.lightGrey2};
    }

    cursor: pointer;
    margin-left: -30px;
    margin-top: 0px; 

  }

  &&.MuiStepLabel-root.Mui-disabled {
    cursor: pointer;
  }
`;

export const StyledStepper = styled(Stepper)`
  && {
    background: "#b8b8b8";
    align-self: center;
    ${(props) => (props.isMobile ? "" : "margin-right: -16px;")}
    ${(props) => (props.isMobile ? "" : "padding-left: 0px;")}
    padding-top: 20px;
    padding-bottom: 0px;
    min-width: 250px;
    margin-left: 10px;
  }
`;

export const SideBarContainer = styled.div`
  width: 5%;
  display: flex;
  flex-direction: column;
  margin-left: -110px;
  margin-top: 20px;
`;

export const SetupContainer = styled.div`
  ${(props) => (!props.isMobile ? "margin-left: 110px" : "")};
  padding-bottom: 32px;
  position: relative;
  z-index=0;
`;

export const FieldArea = styled.div`
  ${(props) =>
    props.marginLeft && !props.isMobile
      ? `margin-left: ${props.marginLeft};`
      : ""}
  margin-top: ${(props) => props.marginTop || "24px"};
  display: flex;
  flex-direction: ${(props) => (props.isColumn ? "column" : "row")};
  align-items: center;
  flex-wrap: wrap;
  ${(props) => (props.noJustifyContent ? "" : "justify-content: center;")}
  ${(props) =>
    props.width && !props.isMobile ? `width: ${props.width};` : "width: 100%;"}

  .last {
    padding-right: 0px !important;
  }

  .inputWrap {
    padding-right: ${(props) => (props.isMobile ? "0px" : "16px")};
    width: ${(props) => (props.isMobile ? "100%" : "50%")};
  }

  .fullWidthInputWrap {
    width: 100%;
  }

  .oneFifthInputWrap {
   padding-right: ${(props) => (props.isMobile ? "0px" : "16px")};
    width: ${(props) => (props.isMobile ? "100%" : "20%")};
  }

  .thirtyInputWrap {
    width: ${(props) => (props.isMobile ? "100%" : "30%")};
  }

  .oneThirdInputWrap {
    width: ${(props) => (props.isMobile ? "100%" : "33.33%")};
  }

  .twoThirdInputWrap {
    width: ${(props) => (props.isMobile ? "100%" : "66.66%")};
  }

  .oneFifthMobile {
    padding-right: 16px;
    width: ${(props) => (props.isMobile ? "50%" : "20%")};
  }

  .thirtyMobile {
    width: ${(props) => (props.isMobile ? "50%" : "30%")};
  }
`;

export const StyledEditRecordButton = styled(FieldArea)`
  align-items: left;
  margin-top: 15px;
`;

export const StyledCard = styled(Card)`
  && {
    width: ${(props) => (props.isMobile ? "155px" : "200px")};
    height: ${(props) => (props.isMobile ? "125px" : "162px")};
    margin-right: 20px;
    box-shadow: none;
    background: ${(props) => (props.isChecked ? COLORS.lighOrange : "white")};
    border: 1px solid
      ${(props) => (props.isChecked ? COLORS.primaryOrange : "#ECEBED")};
    box-sizing: border-box;
    border-radius: 10px;
    ${(props) => (props.isMobile ? "margin-top: 32px;" : "")};
  }
`;

export const StyledCardContent = styled(CardContent)`
  && {
    display: flex;
    flex-direction: column;
    align-items: center;
    ${(props) => (!props.isMobile ? "margin-top: 12px;" : "")};
    ${(props) => (!props.isMobile ? "margin-bottom: 16px;" : "")};
  }
`;

export const StyledCardActionArea = styled(CardActionArea)`
  && {
    // height: 64px;
  }
`;

export const StyledCardContainer = styled.div`
  margin-top: 16px;
`;

export const StyledFlag = styled.img`
  ${(props) => (props.isMobile ? "width: 100px;" : "width: 130px;")};
  ${(props) => (props.isMobile ? "height: 80px;" : "height: 85px;")};
`;

export const StyledCardTypography = styled(Typography)`
  && {
    font-size: 18px;
    font-family: ${TYPOGRAPHY.primaryFont};
    font-weight: 500;
    ${(props) => (!props.isMobile ? "margin-top: 12px;" : "")};
    color: #888888;
  }
`;

export const StyledRow = styled.div`
  display: flex;
  width: 100%;
  ${(props) => (props.margin ? `margin: ${props.margin};` : "")}
  ${(props) =>
    props.justifyContent ? `justify-content: ${props.justifyContent};` : ""}
  flex-direction: ${(props) =>
    props.isMobile || props.isColumn ? "column" : "row"};
`;

export const FieldTitle = styled(Typography)`
  && {
    margin-bottom: 5px;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    width: 100%;
    margin-top: 24px;
  }
`;

export const ProfilePicture = styled(Avatar)`
  && {
    width: ${(props) => (props.isMobile ? "120px" : "200px")};
    height: ${(props) => (props.isMobile ? "120px" : "200px")};
  }
`;

export const EditBadge = styled(Avatar)`
  && {
    width: ${(props) => (props.isMobile ? "29px" : "49px")};
    height: ${(props) => (props.isMobile ? "29px" : "49px")};
    ${(props) =>
    props.isMobile ? "border: 1px solid white;" : "border: 2px solid white;"}
    cursor: pointer;
  }
`;

export const SectionText = styled(Typography)`
  && {
    font-family: ${TYPOGRAPHY.primaryFont};
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: left;
    width: 100%;
    margin-top: ${(props) => props.marginTop || "16px"};
    color: ${COLORS.darkGrey1};
  }
`;

export const StyledAddText = styled.div`
  && {
    color: ${COLORS.primaryOrange};
    cursor: pointer;
    font-family: ${TYPOGRAPHY.primaryFont};
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    font-size: 18px;
    margin-top: 3px;
    margin-left: 10px;
  }
`;

export const TableArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${(props) => (props.isMobile ? "margin-top: -8px;" : "")}
`;

export const AddSignArea = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const StyledMainPanel = styled.div`
  width: 100%;
  margin-top: -20px;
  ${(props) => (props.isMobile ? "" : "margin-left: 40px;")}
`;

export const StyledAutoComplete = styled(Autocomplete)`
  &&.pac-container {
    position: relative !important;
    margin-top: -450px;
  }
`;

export const StyledAuto = styled.div``;

export const StyledAddFinancialText = styled.div`
  color: ${COLORS.primaryOrange};
  cursor: pointer;
  font-family: ${TYPOGRAPHY.primaryFont};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
  margin-right: 16px;
`;

export const ImagePopup = styled.div`
  margin-top: 16px;
`;

export const PopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${(props) => (props.isMobile ? "90%" : "100%")};
  margin-top: 0px;
  justify-content: center;
  align-items: center;
`;

export const ButtonArea = styled.div`
  margin-top: 40px;
  justify-content: center;
  display: flex;
  flex-direction: row;
`;

export const LargeText = styled(Typography)`
  && {
    font-family: ${TYPOGRAPHY.primaryFont};
    font-size: ${(props) => (props.isMobile ? "22px" : "28px")};
    font-style: normal;
    font-weight: 700;
    line-height: 41px;
    letter-spacing: 0px;
    text-align: center;
    margin-top: 24px;
  }
`;

export const SmallText = styled(Typography)`
  && {
    font-family: ${TYPOGRAPHY.secondaryFont};
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: center;
    margin-top: 12px;
  }
`;

export const CompanyLogo = styled(Avatar)`
  && {
    width: ${(props) => (props.isMobile ? "121px" : "182px")};
    height: ${(props) => (props.isMobile ? "114px" : "182px")};
  }
`;

export const LogoPlacementContainer = styled(Avatar)`
  && {
    width: ${(props) => (props.isMobile ? "121px" : "182px")};
    height: ${(props) => (props.isMobile ? "114px" : "182px")};
  }
`;

export const LogoDiv = styled.div`
  width: 100%;
  text-align: left;
  margin: 24px 0px;
  display: flex;
  justify-content: center;
`;

export const SecondRadioContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SecondInnerRadioContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledTextField = styled(TextField)`
  && {
    width: ${(props) => (props.width ? props.width : "100%")};
    border-color: ${(props) => (props.noBorderColor ? "" : COLORS.lightGrey1)};
    background-color: white;

    .MuiOutlinedInput-notchedOutline {
      border-color: ${(props) =>
    props.noBorderColor ? "" : COLORS.lightGrey1};
    }

    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${COLORS.primaryOrange};
      border-width: thin;
    }

    .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${COLORS.primaryOrange};
    }
  }
`;
